import React, { Fragment } from 'react';
import { add as addToCartService } from '../Services/Cart.service';
import withReactiveStyleBuyButton from './withReactiveStyleBuyButton';
import { receive, loadError } from '../Actions/Cart.action';
import { catchError } from '../Actions/Error.action';
import { useDispatch } from 'react-redux';
import { translate } from '../Services/translation';

const AccessoryBuyButton = ({
    label,
    articleNumber,
    quantityFieldId,
    packageQuantity,
    href,
    cssClass,
    onClick,
}) => {
    return (
        <Fragment>
            {articleNumber ? (
                <button
                    aria-label={translate('product.buy')}
                    className={cssClass}
                    onClick={() => onClick({ articleNumber, quantityFieldId, packageQuantity })}
                >
                    {label ? <span className="atc-button-content atc-button-content--large"><span className="atc-button-content--label">{label}</span><i className="status-icon"></i></span> : <span className="atc-button-content atc-button-content--small"><i className='product__footer--cart-icon atc-button-content--label'></i><i className="status-icon"></i></span>}
                </button>
            ) : (
                <a className={cssClass} href={href} aria-label={translate('product.buy')}>
                    {label ? <span className="atc-button-content atc-button-content--large"><span className="atc-button-content--label">{label}</span><i className="status-icon"></i></span> : <span className="atc-button-content atc-button-content--small"><i className='product__footer--cart-icon atc-button-content--label'></i><i className="status-icon"></i></span>}
                </a>
            )}
        </Fragment>
    );
};

const StyledAccessoryBuyButton = (props) => {
    const dispatch = useDispatch();
    const onClick = async ({ articleNumber, quantityFieldId, packageQuantity }) => {

        try {
            let quantity = quantityFieldId
                ? document.getElementById(quantityFieldId).value
                : 1;

            if(!quantityFieldId){
                quantity = quantity * packageQuantity;
            }

            const cart = await addToCartService({ articleNumber, quantity });
            dispatch(receive(cart));
            return true;
        } catch (ex) {
            dispatch(catchError(ex, (error) => loadError(error)));
            return false;
        }
    };
    const Button = withReactiveStyleBuyButton(AccessoryBuyButton, onClick, 'accessory-buy-button');
    return <Button {...props} />;
};

export default StyledAccessoryBuyButton;